module.exports = __webpack_public_path__ + "static/media/homepage-header-image@2x.bbdadb97.png";